import(/* webpackMode: "eager", webpackExports: ["Details"] */ "/app/apps/todoist-landing-pages/app/[locale]/integrations/apps/[integration]/components/details/details.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntegrationPageHeader"] */ "/app/apps/todoist-landing-pages/app/[locale]/integrations/apps/[integration]/components/integrations-page-header/integration-page-header.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/integrations/apps/[integration]/components/integrations-page/integrations-page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["SideInfo"] */ "/app/apps/todoist-landing-pages/app/[locale]/integrations/apps/[integration]/components/side-info/side-info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Prefooter"] */ "/app/apps/todoist-landing-pages/app/[locale]/integrations/components/common/prefooter/prefooter.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/container-sidebar/container-sidebar.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
